var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 72 72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "plus-a",
    d: "M42,30.008622 L64,30.008622 C65.1045695,30.008622 66,30.9040525 66,32.008622 L66,40.008622 C66,41.1131915 65.1045695,42.008622 64,42.008622 L42,42.008622 L42,64 C42,65.1045695 41.1045695,66 40,66 L32,66 C30.8954305,66 30,65.1045695 30,64 L30,42.008622 L8,42.008622 C6.8954305,42.008622 6,41.1131915 6,40.008622 L6,32.008622 C6,30.9040525 6.8954305,30.008622 8,30.008622 L30,30.008622 L30,8 C30,6.8954305 30.8954305,6 32,6 L40,6 C41.1045695,6 42,6.8954305 42,8 L42,30.008622 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#plus-a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plus.a77b1671fdaff07092a26e51f34fe551.svg";